import Contacto from '../components/common/Contacto'
import Estatico from '../components/common/Estatico'
import Inicio from '../components/common/Inicio'
import Modular from '../components/common/Modular'
import AltaCliente from '../components/ecommerce/AltaCliente'
import Articulo from '../components/ecommerce/Articulo'
import Articulos from '../components/ecommerce/Articulos'
import ArticulosListItems from '../components/ecommerce/ArticulosListItems'
import Cardnet from '../components/ecommerce/Cardnet'
import ExcelPedido from '../components/ecommerce/ExcelPedido'
import Home from '../components/ecommerce/Home'
import Informes from '../components/ecommerce/Informes'
import ListasCompra from '../components/ecommerce/ListasCompra'
import NovedadesOfertas from '../components/ecommerce/NovedadesOfertas'
import OfertasWeb from '../components/ecommerce/OfertasWeb'
import PaymentDone from '../components/ecommerce/PaymentDone'
import Pedido from '../components/ecommerce/Pedido'
import PedidoHabitual from '../components/ecommerce/PedidoHabitual'
import PedidosAnteriores from '../components/ecommerce/PedidosAnteriores'
import PedidosPendientes from '../components/ecommerce/PedidosPendientes'
import Resumen from '../components/ecommerce/ResumenCasals'
import Wompi from '../components/ecommerce/Wompi'
import EfacturaCompras from '../components/efactura/EfacturaCompras'
import EfacturaVentas from '../components/efactura/EfacturaVentas'
import Conversaciones from '../components/expedientes/Conversaciones'
import Expedientes from '../components/expedientes/Expedientes'
import Plantillas from '../components/plantillas/Plantillas'
import Cuenta from '../components/usuarios/Cuenta'
import Login from '../components/usuarios/Login'
import Logout from '../components/usuarios/Logout'
import Recuperar from '../components/usuarios/Recuperar'
import Registro from '../components/usuarios/Registro'
import RegistroCompleto from '../components/usuarios/RegistroCompleto'
import Documentos from '../components/documentos/components/Documentos'


import RegistroHijo from '../components/usuarios/RegistroHijo'
import Widgets from '../components/widgets/Widgets'

const programasRutas = {
  conversaciones: <Conversaciones />,
  login: <Login />,
  articulos: <Articulos />,
  articulo: <Articulo />,
  cuenta: <Cuenta />,
  informes: <Informes />,
  resumen: <Resumen />,
  registro: <Registro />,
  logout: <Logout />,
  recuperar: <Recuperar />,
  listasCompra: <ListasCompra />,
  inicio: <Inicio />,
  estatico: <Estatico />,
  contacto: <Contacto />,
  pedidosAnteriores: <PedidosAnteriores />,
  pedidosPendientes: <PedidosPendientes />,
  pedidoHabitual: <PedidoHabitual />,
  novedadesOfertas: <NovedadesOfertas />,
  widgets: <Widgets />,
  registroCompleto: <RegistroCompleto />,
  pedido: <Pedido />,
  home: <Home />,
  wompi: <Wompi />,
  cardnet: <Cardnet />,
  modular: <Modular />,
  registroHijos: <RegistroHijo />,
  efacturaVentas: <EfacturaVentas />,
  efacturaCompras: <EfacturaCompras />,
  expedientes: <Expedientes />,
  plantillas: <Plantillas />,
  ofertasWeb: <OfertasWeb />,
  altaCliente: <AltaCliente />,
  articulosListItems: <ArticulosListItems />,
  pagoRealizado: <PaymentDone />,
  excelPedido: <ExcelPedido />,
  documentacion: <Documentos />,
}

export default programasRutas
